module.exports = __webpack_public_path__ + "img/vineyard-logo.a5d188d5.jpg";